
<template>
  <div>
    <div class="topbar" style="z-index: 10;">
      <TopBar />
    </div>
    <!-- <div class="homepage">
      <HomePage />
    </div>  -->
    <div class="router">
      <router-view></router-view>
    </div>
  </div>

</template>
<script>
// import HomePage from './views/pannels/HomePage.vue'

import TopBar from './views/components/TopBar.vue'

// import { register, login } from '@/api/auth'


export default {
  name: 'App',
  components: {
    // HomePage,
    TopBar
},
  data() {
    return {
      showLogin: false,
      ai_response:''
    }
  },
  created() {
    // if(this.$store.state.currentRoute != 'homepage') { //防止重复导航
    //   this.$router.push({name: 'homepage'})
    //   this.$store.commit('setCurrentRoute', 'homepage')
    // }
  },
 
  methods: {
    showLoginPage(ifshow) {
      this.showLogin = ifshow
    }
    
      },
  mounted() {
        // this.$store.commit('setLoginStatus', false)
        console.log('欢迎回来',this.$store.state.username)
    }
}
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
  }
  #app {
    margin: 0;
    padding: 0;
  }
  .topbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
  .logo {
    position: absolute;
    left:18px;
    top:12px;
    z-index: 10;
  }
  .loginPage{
    position: absolute;
    left: 0;
    top:0;
    width: 100vw;
    height: 100vh;
  }
  p{
    margin: 0;
    margin-block-start: 0em;
    margin-block-end: -1em;
  }
  ol{
    margin: 0;
  }
</style>
